<div class="content">
  <span class="title">Support for myViewBoard Clips is nearing the end</span>
  <img src="images/RemoveClips.png" />
  <span class="text"
    >Please note that starting January 2023 myViewBoard Suite will no longer
    provide this service in our products.</span
  >
</div>
